import AnalyticsEventTypes from 'components/analytics/AnalyticsEventTypes';
import BasicAccordion from 'components/basicAccordion/BasicAccordion';
import 'components/domutils/Element.jQuery';

export default {
  initialize(faqAccordionContainer) {
    BasicAccordion.attachTo(faqAccordionContainer, {
      contentSelector: '.js-faqAnswer',
      toggleSelector: '.js-toggleAnswer',
    });

    setTimeout(() => {
      this.addFaqHandlers();
    }, 0);
  },

  addFaqHandlers() {
    const toggleSelectors = document.querySelectorAll('.js-toggleAnswer, .js-faqTopic');

    if (!toggleSelectors.length) {
      return;
    }

    toggleSelectors.forEach(toggleSelector =>
      toggleSelector.jq.on('vclick', event => {
        const target = event.currentTarget;

        if (target.href) {
          event.preventDefault();
        }

        if (target.classList.contains('is-active')) {
          return;
        }

        let eventCallback;
        let timeoutId;

        if (target.href) {
          eventCallback = () => {
            clearTimeout(timeoutId);
            window.location = target.href;
          };
        }

        document.jq.trigger(AnalyticsEventTypes.FAQ_ITEM_OPEN, {
          eventCallback,
          label: target.dataset.labelEn.toLowerCase(),
        });

        if (target.href) {
          timeoutId = setTimeout(eventCallback, 750);
        }
      })
    );

    const scrollToSection = sectionId => {
      const element = document.querySelector(`${sectionId}`);

      if (element) {
        const headerOffset = 60;
        const elementPosition = element.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.scrollY - headerOffset;

        window.scrollTo({
          top: offsetPosition,
          behavior: 'smooth',
        });
      }
    };

    const currentHash = window.location.hash;

    window.setTimeout(() => {
      if (currentHash) {
        const currentSection = document.querySelector(`${currentHash} h3.js-toggleAnswer`);

        if (currentSection) {
          currentSection.click();
          scrollToSection(currentHash);
        }
      }
    }, 0);
  },
};
